import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { useForm, Controller } from 'react-hook-form'
import { Circles } from 'react-loader-spinner'
import { Form } from 'react-bootstrap'
// import { toast, ToastContainer } from 'react-toastify'
const phoneMaskGenerator = createDefaultMaskGenerator('(999) 999-9999')
import 'react-toastify/dist/ReactToastify.css'
import './login.scss'
import { getConfigDetails } from '../../services/config'
// import { newpasswordValidation } from '../../constants/globalConstants'
import { isPermissionExist, sortPortalPermissionByKey } from '../../utils/helper'
import { globalKeyStore } from '../../redux/actions/globalState'
import { userLogin, userSingUp } from '../../redux/actions/login'


function ModalLogin({ show, isLoading, dispatch, notify, globalData, modalSingup, errorMessage }) {

    const { register, handleSubmit, formState: { errors }, control, reset } = useForm()

    // const location = useLocation()?.pathname

    const handleClose = () => dispatch(globalKeyStore({ isLoginModal: false }))

    const getAccessPermissionData = sortPortalPermissionByKey(globalData, 'Access Permissions')

    const navigate = useNavigate()
    const {facility} = useParams()
    const location = useLocation()
    // console.log(location.pathname.includes('/paymentsuccess'), 'Current Location')

    const partner = window.location.toString().split('/')[3]
    const [passwordShown, setPasswordShown] = useState(false)
    const [cpasswordShown, setCPasswordShown] = useState(false)
    const [mpasswordShown, setMPasswordShown] = useState(false)
    const [error, setError] = useState({ password_strength: false, confirm_password_strength: false })

// console.log('errors' ,errors)
    const togglePasswordVisiblity = (e, key) => {
        if (key === 'password') {
            setPasswordShown(passwordShown ? false : true)
        }
        if (key === 'mpassword') {
            setMPasswordShown(mpasswordShown ? false : true)
        }
        if (key === 'cpassword') {
            setCPasswordShown(cpasswordShown ? false : true)
        }
    }

    const handleInputChange = (e) => {
        const { name } = e.target
        if (name == 'password') {
            setError({ ...error, password_strength: false })
        } else {
            setError({ ...error, confirm_password_strength: false })
        }
    }

    const handleSecondModal = () => {
        reset(formValues => ({ ...formValues, username: '', password: '' }))
        dispatch(globalKeyStore({ modalSingup: 1 }))
    }

    const onSignIn = (data) => {
        const clientId = JSON.parse(localStorage.getItem('client_id'))
        dispatch(globalKeyStore({ isLoading: true }))
        const tempPayload = { 'username': '', 'password': '', 'client_id': getConfigDetails()?.CLIENT_ID?getConfigDetails()?.CLIENT_ID : clientId.id, 'client_secret': clientId.secret ? clientId.secret : getConfigDetails()?.CLIENT_SECRET, 'grant_type': 'password' }

        const loginPayload = { ...tempPayload, ...data }

        if (loginPayload?.username != '' && loginPayload?.password != '') {
            dispatch(userLogin(loginPayload)).then((res) => {
                dispatch(globalKeyStore({ isLoading: false }))
                const userData = res?.data
                if (userData) {
                    localStorage.setItem('isLoggedIn', true)
                    localStorage.setItem('userData', JSON.stringify(userData))
                    reset(formValues => ({ ...formValues, 'username': '', 'password': '' }))
                    dispatch(globalKeyStore({ isLoading: false, isLoginModal: false, isLoggedIn: true }))
                    notify('success', 'You Login Successfully!')
                    if(location.pathname.includes('/paymentsuccess') || location.pathname.includes('/reset-password')) {
                        window.location.href = partner
                    }
                } else {
                    dispatch(globalKeyStore({ errorMessage: res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!' }))
                    notify('error', res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!')
                }
            }).catch((err) => {
                const response = err?.errors
                dispatch(globalKeyStore({ isLoading: false, errorMessage: response?.message ? response?.message : 'Something went wrong, Please try again!' }))
                notify('error', response?.message ? response?.message : 'Something went wrong, Please try again!')
            })
        } else {
            dispatch(globalKeyStore({ isLoading: false, errorMessage: 'Please enter user name & password' }))
        }
    }

    const onSignUp = (data) => {
        const clientId = JSON.parse(localStorage.getItem('client_id'))
        dispatch(globalKeyStore({ isLoading: true }))
        if (data?.cpassword === data?.password) {
            const payload = { 'first_name': '', 'last_name': '', 'email': '', 'phone': '', 'confirm_password': '', 'client_secret': getConfigDetails()?.CLIENT_SECRET }
            const finalPayload = { ...payload, ...data }
            finalPayload['confirm_password'] = finalPayload?.cpassword
            delete finalPayload?.password
            delete finalPayload?.cpassword
            delete finalPayload?.username
            dispatch(userSingUp(finalPayload)).then((res) => {
                if (res?.data) {
                    const loginPayload = { 'username': '', 'password': '', 'client_id': getConfigDetails()?.CLIENT_ID ? getConfigDetails()?.CLIENT_ID : clientId.id, 'client_secret': clientId.secret ? clientId.secret : getConfigDetails()?.CLIENT_SECRET, 'grant_type': 'password' }
                    loginPayload['username'] = data?.email
                    loginPayload['password'] = finalPayload?.confirm_password
                    localStorage?.setItem('userData', JSON.stringify(res?.data))
                    notify('success', 'Registration Successfully Completed')
                    dispatch(userLogin(loginPayload)).then((res) => {
                        const userData = res?.data
                        if (userData) {
                            localStorage.setItem('isLoggedIn', true)
                            localStorage.setItem('userData', JSON.stringify(userData))
                            dispatch(globalKeyStore({ isLoading: false, isLoginModal: false, isLoggedIn: true }))
                            notify('success', 'You Login Successfully!')
                            if(location.pathname.includes('/paymentsuccess')) {
                                window.location.href = partner
                            }
                        } else {
                            dispatch(globalKeyStore({ isLoading: false, isLoginModal: false, errorMessage: res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!' }))
                            notify('error', res?.errors?.message ? res?.errors?.message : 'Something went wrong, Please try again!')
                        }
                    }).catch((err) => {
                        const response = err?.errors
                        dispatch(globalKeyStore({ isLoading: false, isLoginModal: false, errorMessage: response?.message ? response?.message : 'Something went wrong, Please try again!' }))
                        notify('error', response?.message ? response?.message : 'Something went wrong, Please try again!')
                    })
                    reset(formValues => ({ ...formValues, 'first_name': '', 'last_name': '', 'email': '', 'phone': '', 'confirm_password': '', 'password': '', 'cpassword': '', 'client_secret': getConfigDetails()?.CLIENT_SECRET }))
                    dispatch(globalKeyStore({ isLoading: false,  isLoginModal: false, isLoggedIn: true }))
                } else {
                    notify('error', res?.errors?.message)
                    dispatch(globalKeyStore({ isLoading: false }))
                }
            })
        } else {
            notify('error', 'Password not match')
            dispatch(globalKeyStore({ isLoading: false }))
        }
    }

    const handleBackButton = () => {
        reset(formValues => ({ ...formValues, email: '', phone: '', first_name: '', cpassword: '', password: '' }))
        dispatch(globalKeyStore({ modalSingup: 0 }))
    }

    const handleForgotPassword = () => {
        // navigate(`/${partner}${URL?.BASE_SEND_EMAIL_FORGOT_PASSWORD}`)
        if(facility){
            navigate(`/${partner}/${facility}/forgotpassword`)
        }
        else{
            navigate(`/${partner}/forgotpassword`)
        }
        dispatch(globalKeyStore({ isLoginModal: false }))
    }
    
    return (
        <>
            <Modal show={show} size={modalSingup === 1 ? 'lg' : null} onHide={handleClose}>
                {modalSingup === 0 &&
                    <form onSubmit={handleSubmit(onSignIn)}>
                        <Modal.Header closeButton> <Modal.Title>Login</Modal.Title> </Modal.Header>
                        <Modal.Body>
                            <div className="mb-3">
                                <label htmlFor="exampleInputEmail1" className="form-label">User Name <span style={{ color: 'red' }}>*</span></label>
                                <input type="email" name='username' className="form-control" maxLength='40' minLength='1' placeholder="" {...register('username', {
                                    required: true,
                                    pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: 'invalid email address' }
                                })} />
                                {errors?.username?.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                                {errors?.username?.type === 'pattern' && <span style={{ color: 'red' }}>{errors?.username?.message}</span>}
                            </div>

                            <div className="mb-3 myiconset">
                                <label htmlFor="exampleInputPassword1" className="form-label">Password <span style={{ color: 'red' }}>*</span></label>
                                <input type={passwordShown ? 'text' : 'password'} name='password' className="form-control passwordInput" id="exampleInputPassword1"   {...register('password', { required: true })} />
                                <i className={passwordShown ? 'fas fa-eye-slash loginPassIcon' : 'fas fa-eye loginPassIcon'} onClick={(e) => togglePasswordVisiblity(e, 'password')}></i>
                                {errors?.password?.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                            </div>
                            <div className='mb-3 cursor' >
                                <span className="form-label" onClick={() => { handleForgotPassword() }}>Forgot Password? </span>
                            </div>

                            <div className="mb-3">
                                <Button variant="primary" type='submit' className="btn btn-primary btn-lg w-100" disabled={(isLoading) ? true : false} onClick={(e) => handleSubmit(e)}>
                                    <div className='d-flex justify-content-center align-items-center' disabled={(isLoading) ? true : false}>
                                        <span>Sign in </span>  <span className='ms-2'>
                                            {isLoading ? <Circles
                                                height="20"
                                                width="20"
                                                style={{ display: 'inline-block' }}
                                                color="#ffffff"
                                                ariaLabel="circles-loading"
                                                visible={true}
                                            /> : null}
                                        </span>
                                    </div>
                                </Button>
                            </div>
                            <span className='text-danger'>{errorMessage}</span>
                            {(isPermissionExist(getAccessPermissionData, 'Signup Access')) && <div className="mb-3 text-center">
                                New on our platform? <a type='button' className='text-primary' role='button' onClick={handleSecondModal}>Create an account</a>
                            </div>}
                        </Modal.Body>
                    </form>
                }
                {modalSingup === 1 &&
                    <form onSubmit={handleSubmit(onSignUp)}>
                        <Modal.Header closeButton> <Modal.Title>Register your Account</Modal.Title></Modal.Header>
                        <Modal.Body>
                            <div className="checkinForm">
                                <div className='row'>
                                    <div className='col'>
                                        <div className="mt-2">
                                            <label htmlFor="" className="form-label">First Name <span style={{ color: 'red' }}>*</span></label>
                                            <input type="text" className="form-control" name='first_name' id="first_name" placeholder="Enter First Name" {...register('first_name', { required: true })} />
                                        </div>
                                        {errors?.first_name?.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                                    </div>
                                    <div className='col'>
                                        <div className="mt-2">
                                            <label htmlFor="" className="form-label">Last Name</label>
                                            <input type="text" name='last_name' className="form-control" id="last_name" placeholder="Enter Last Name" {...register('last_name')} />
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col'>
                                        <div className="mt-2">
                                            <label htmlFor="" className="form-label">Email <span style={{ color: 'red' }}>*</span></label>
                                            <input type="email" name='email' className="form-control" maxLength='40' minLength='1' placeholder="Enter your email" {...register('email', {
                                                required: true,
                                                pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: 'invalid email address' }
                                            })} />
                                        </div>
                                        {errors?.email?.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                                        {errors?.email?.type === 'pattern' && <span style={{ color: 'red' }}>{errors?.email?.message}</span>}
                                    </div>
                                    <div className='col'>
                                        <div className="mt-2">
                                            <label htmlFor="" className="form-label">Phone <span style={{ color: 'red' }}>*</span></label>
                                            <Controller
                                                name="phone"
                                                type="text"
                                                id="phone"
                                                control={control}
                                                rules={{ required: true, maxLength: 14, minLength: 10 }}
                                                render={({ field }) => <MaskedInput
                                                    maskGenerator={phoneMaskGenerator}
                                                    className="form-control"
                                                    {...field}
                                                    maxLength={14}
                                                    minLength={10}
                                                    title="Please enter a valid phone number"
                                                    onInvalid={e => e.target.setCustomValidity('Please enter phone number')}
                                                    onInput={e => e.target.setCustomValidity('')}
                                                    placeholder="Phone Number"
                                                />}
                                            />
                                        </div>
                                        {errors?.phone?.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                                        {errors?.phone?.type === 'minLength' && <span style={{ color: 'red' }}>{(errors?.phone?.message) ? errors?.phone?.message : 'Please enter a valid phone number'}</span>}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-6 myiconset">
                                        <div className="mt-2">
                                            <label htmlFor="" className="form-label">Password <span style={{ color: 'red' }}>*</span></label>
                                            <input className="form-control ng-untouched ng-pristine ng-invalid passwordInput"
                                                name="password" placeholder="Create Password"
                                                {...register('password', { required: true, onChange: (e) => handleInputChange(e) })}
                                                type={mpasswordShown ? 'text' : 'password'} />
                                        </div>
                                        <i className={mpasswordShown ? 'fas fa-eye-slash iconset' : 'fas fa-eye iconset'} onClick={(e) => togglePasswordVisiblity(e, 'mpassword')}></i>
                                        {errors?.password?.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                                        {(error?.password_strength) && <Form.Text className="text-danger">Password should 8 to 15 characters, at least one uppercase letter, one lowercase letter, one number and one special character.</Form.Text>}
                                    </div>
                                    <div className="col-sm-6 myiconset">
                                        <div className="mt-2">
                                            <label htmlFor="" className="form-label">Confirm Password <span style={{ color: 'red' }}>*</span></label>
                                            <input className="form-control ng-untouched ng-pristine ng-invalid passwordInput"
                                                {...register('cpassword', { required: true, onChange: (e) => handleInputChange(e) })}
                                                name="cpassword" placeholder="Confirm Password"
                                                type={cpasswordShown ? 'text' : 'password'} />
                                        </div>
                                        <i className={cpasswordShown ? 'fas fa-eye-slash iconset' : 'fas fa-eye iconset'} onClick={(e) => togglePasswordVisiblity(e, 'cpassword')}></i>
                                        {errors?.cpassword?.type === 'required' && <span style={{ color: 'red' }}>This field is required</span>}
                                        {(error?.confirm_password_strength) && <Form.Text className="text-danger">Password should 8 to 15 characters, at least one uppercase letter, one lowercase letter, one number and one special character.</Form.Text>}
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-outline-secondary me-auto" type='button' onClick={handleBackButton} disabled={(isLoading) ? true : false}><i className="fa fa-angle-left"></i> Back To Login</button>
                            <Button type="submit" className="btn btn-primary" disabled={(isLoading) ? true : false}>
                                <div className='d-flex aling-items-center'>
                                    <span>Submit</span> <span className='ms-2'>
                                        {isLoading ? <Circles
                                            height="20"
                                            width="20"
                                            style={{ display: 'inline-block' }}
                                            color="#ffffff"
                                            ariaLabel="circles-loading"
                                            visible={true}
                                        /> : null}
                                    </span>
                                </div>
                            </Button>
                        </Modal.Footer>
                    </form>
                }
            </Modal>
        </>
    )
}
ModalLogin.propTypes = {
    dispatch: PropTypes.func,
    data: PropTypes.object,
    setShow: PropTypes.func,
    show: PropTypes.bool,
    isLoading: PropTypes.bool,
    notify: PropTypes.func,
    globalData: PropTypes.object,
    modalSingup: PropTypes.number,
    loginPayload: PropTypes.object,
    errorMessage: PropTypes.string
}

ModalLogin.defaulProps = {
    dispatch: noop,
    data: EMPTY_OBJECT,
    setShow: noop,
    show: false,
    isLoading: false,
    globalData: EMPTY_OBJECT,
    notify: noop,
    modalSingup: 0,
    loginPayload: EMPTY_OBJECT,
    errorMessage: ''
}

function mapStateToProps({ globalReducers }) {
    return {
        show: globalReducers?.isLoginModal,
        globalData: globalReducers?.partnerDetails?.customer_portal_permission,
        modalSingup: globalReducers?.modalSingup,
        isLoading: globalReducers?.isLoading,
        errorMessage: globalReducers?.errorMessage,
        loginPayload: globalReducers?.loginPayload
    }
}
export default connect(mapStateToProps)(ModalLogin)